import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { toast } from "sonner";

const SITE_URL = "https://heveatalent.com.br";

export const buildShareText = (job) => {
  const publicUrl = `${SITE_URL}/vaga/${job.id}`;
  const location = job.location || job.city || "";
  return [
    job.urgent ? "🔥 *VAGA URGENTE: SANGRADOR DE SERINGUEIRA* 🔥" : "🌳 *VAGA: SANGRADOR DE SERINGUEIRA* 🌳",
    "",
    `📌 *${job.title}*`,
    location ? `📍 ${location}` : null,
    job.salary_range ? `💰 ${job.salary_range}` : null,
    "",
    "👇 *COMO SE CANDIDATAR:*",
    "Entre no link → cadastre-se grátis → informe sua referência → veja o contato e fale direto com quem contrata:",
    "",
    publicUrl,
    "",
    "✅ Grátis | ✅ Sem intermediário | ✅ Vaga verificada HeveaTalent",
  ].filter((l) => l !== null).join("\n");
};

export const buildDigestText = (jobs, opts = {}) => {
  const nums = ["1️⃣","2️⃣","3️⃣","4️⃣","5️⃣","6️⃣","7️⃣","8️⃣","9️⃣","🔟"];
  const hoje = new Date().toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
  const ordered = [...jobs].sort((a, b) => (b.urgent === true) - (a.urgent === true));
  const lines = [
    `🌳 *HEVEATALENT — VAGAS DE HOJE ${hoje}* 🌳`,
    opts.confirmed
      ? `✅ *${ordered.length} vaga${ordered.length > 1 ? "s" : ""} CONFIRMADA${ordered.length > 1 ? "S" : ""} como disponíve${ordered.length > 1 ? "is" : "l"} hoje*`
      : `🔥 *${ordered.length} oportunidade${ordered.length > 1 ? "s" : ""} na seringueira AGORA*`,
    "",
  ];
  ordered.forEach((job, i) => {
    const loc = job.location || job.city || "";
    lines.push(`${nums[i] || `▪️ ${i + 1}.`} ${job.urgent ? "🔥 *URGENTE* — " : ""}*${job.title}*`);
    const detail = [loc ? `📍 ${loc}` : null, job.salary_range ? `💰 ${job.salary_range}` : null].filter(Boolean).join("  ·  ");
    if (detail) lines.push(detail);
    lines.push(`👉 ${SITE_URL}/vaga/${job.id}`);
    lines.push("");
  });
  lines.push("👇 *COMO SE CANDIDATAR:*");
  lines.push("Entre no link → cadastre-se grátis → informe sua referência → fale direto com quem contrata.");
  lines.push("");
  lines.push("✅ Grátis | ✅ Sem intermediário | ✅ Vagas verificadas");
  lines.push("");
  lines.push("⚠️ As vagas fecham rápido — garanta a sua hoje.");
  lines.push(`🔗 Todas as vagas por cidade: ${SITE_URL}/vagas`);
  return lines.join("\n");
};

export const ShareJobDialog = ({ job, open, onOpenChange }) => {
  if (!job) return null;
  const shareText = buildShareText(job);

  const copyText = async () => {
    try {
      await navigator.clipboard.writeText(shareText);
      toast.success("Texto copiado! É só colar no grupo.");
    } catch {
      toast.error("Não consegui copiar — selecione o texto manualmente.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="share-job-dialog">
        <DialogHeader>
          <DialogTitle>📢 Divulgar vaga nos grupos</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-gray-500 -mt-2">
          O anúncio NÃO mostra o contato — quem se interessar se cadastra na plataforma e informa as referências para ver. 🚀
        </p>

        <div>
          <p className="text-sm font-medium mb-1">Mensagem pronta para o grupo:</p>
          <textarea
            readOnly
            value={shareText}
            className="w-full text-sm border rounded-lg p-3 bg-gray-50 h-56"
            data-testid="share-job-text"
          />
          <div className="flex flex-wrap gap-2 mt-2">
            <Button size="sm" onClick={copyText} data-testid="share-job-copy-btn">
              📋 Copiar texto
            </Button>
            <a
              href={`https://wa.me/?text=${encodeURIComponent(shareText)}`}
              target="_blank"
              rel="noreferrer"
              data-testid="share-job-whatsapp-btn"
            >
              <Button size="sm" className="bg-green-600 hover:bg-green-700">💬 Enviar no WhatsApp</Button>
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
